import React from 'react';
import { useLocalization } from '@/Hooks';
import { Modal } from '@/Components/Modal/Modal';
import styles from './SelectTemplateModal.scss';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { SelectTemplateTable } from './SelectTemplateTable';
import { Label } from '@/Components/Controls/Label/Label';
import { FormSelectInput } from '@/Components/Controls/SelectInput/FormSelectInput';
import { FormData, useSelectTemplateModal } from './hooks/useSelectTemplateModal';
import { Tooltip } from '@/Components/Tooltip/Tooltip';
import { useRequired } from '@/Hooks/Validation';
import { useSelectTemplateOptions } from './hooks/useSelectTemplateOptions';

type Props = {
  onClose: () => void;
};

export const SelectTemplateModal = ({ onClose }: Props) => {
  const {
    buttons,
    modalWindows: {
      documentPrintModal: { SelectTemplateModal },
    },
  } = useLocalization();

  const {
    methods: { register, setValue, print },
    errors,
  } = useSelectTemplateModal(onClose);

  const { orderTypeOptions, documentPrintState, isSortActive } = useSelectTemplateOptions();

  const required = useRequired(isSortActive);

  return (
    <Modal
      onClose={onClose}
      tourKey={'documentPrintTour'}
      modalId={'documentPrintModal'}
      className={styles.modal}
      description={{
        title: SelectTemplateModal.Title,
      }}
    >
      <form onSubmit={print} className={styles.form}>
        <SelectTemplateTable />

        <Label text={SelectTemplateModal.PrintingOrder} className={styles.printOrder}>
          <FormSelectInput<FormData>
            options={orderTypeOptions}
            name="orderType"
            register={register}
            setValue={setValue}
            rules={required}
            error={errors}
            disabled={!isSortActive}
            needClearButton={false}
          />
        </Label>

        <ButtonsWrapper>
          <div>
            <Button theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} text={buttons.Cancel} onClick={onClose} />
            <Tooltip
              className={styles.disabledMessage}
              shouldShowOnHover={documentPrintState.disabled}
              text={documentPrintState.message}
            >
              <Button
                autoFocus={true}
                text={buttons.Print}
                theme={BUTTON_THEMES.SUCCESS}
                type={'submit'}
                disabled={documentPrintState.disabled}
              />
            </Tooltip>
          </div>
        </ButtonsWrapper>
      </form>
    </Modal>
  );
};
